/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Create_AccountInputs */

const th_admin_create_account = /** @type {(inputs: Admin_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สร้างบัญชี`)
};

const en_admin_create_account = /** @type {(inputs: Admin_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create an account`)
};

const ja_admin_create_account = /** @type {(inputs: Admin_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントを作成`)
};

const zh_admin_create_account = /** @type {(inputs: Admin_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建账户`)
};

const es_admin_create_account = /** @type {(inputs: Admin_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear una cuenta`)
};

const pt_admin_create_account = /** @type {(inputs: Admin_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar uma conta`)
};

const id_admin_create_account = /** @type {(inputs: Admin_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat akun`)
};

const fr_admin_create_account = /** @type {(inputs: Admin_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un compte`)
};

const tl_admin_create_account = /** @type {(inputs: Admin_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gumawa ng account`)
};

const vi_admin_create_account = /** @type {(inputs: Admin_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo tài khoản`)
};

const ko_admin_create_account = /** @type {(inputs: Admin_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정 만들기`)
};

const de_admin_create_account = /** @type {(inputs: Admin_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto anlegen`)
};

const ru_admin_create_account = /** @type {(inputs: Admin_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать аккаунт`)
};

const tr_admin_create_account = /** @type {(inputs: Admin_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hesap oluştur`)
};

const it_admin_create_account = /** @type {(inputs: Admin_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea account`)
};

const pl_admin_create_account = /** @type {(inputs: Admin_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utwórz konto`)
};

const uk_admin_create_account = /** @type {(inputs: Admin_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Створити обліковий запис`)
};

const hi_admin_create_account = /** @type {(inputs: Admin_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खाता बनाएँ`)
};

const ar_admin_create_account = /** @type {(inputs: Admin_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إنشاء حساب`)
};

const ms_admin_create_account = /** @type {(inputs: Admin_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cipta akaun`)
};

const bn_admin_create_account = /** @type {(inputs: Admin_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অ্যাকাউন্ট তৈরি করুন`)
};

const zh_tw2_admin_create_account = /** @type {(inputs: Admin_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建立帳戶`)
};

const zh_hk2_admin_create_account = /** @type {(inputs: Admin_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建立帳戶`)
};

const ur_admin_create_account = /** @type {(inputs: Admin_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اکاؤنٹ بنائیں`)
};

const fa_admin_create_account = /** @type {(inputs: Admin_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ساختن حساب`)
};

const sw_admin_create_account = /** @type {(inputs: Admin_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fungua akaunti`)
};

const nl_admin_create_account = /** @type {(inputs: Admin_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account aanmaken`)
};

/**
* | output |
* | --- |
* | "Create an account" |
*
* @param {Admin_Create_AccountInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const admin_create_account = /** @type {((inputs?: Admin_Create_AccountInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Create_AccountInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_admin_create_account(inputs)
	if (locale === "ja") return ja_admin_create_account(inputs)
	if (locale === "zh") return zh_admin_create_account(inputs)
	if (locale === "es") return es_admin_create_account(inputs)
	if (locale === "pt") return pt_admin_create_account(inputs)
	if (locale === "id") return id_admin_create_account(inputs)
	if (locale === "fr") return fr_admin_create_account(inputs)
	if (locale === "tl") return tl_admin_create_account(inputs)
	if (locale === "vi") return vi_admin_create_account(inputs)
	if (locale === "ko") return ko_admin_create_account(inputs)
	if (locale === "de") return de_admin_create_account(inputs)
	if (locale === "ru") return ru_admin_create_account(inputs)
	if (locale === "tr") return tr_admin_create_account(inputs)
	if (locale === "it") return it_admin_create_account(inputs)
	if (locale === "pl") return pl_admin_create_account(inputs)
	if (locale === "uk") return uk_admin_create_account(inputs)
	if (locale === "hi") return hi_admin_create_account(inputs)
	if (locale === "ar") return ar_admin_create_account(inputs)
	if (locale === "ms") return ms_admin_create_account(inputs)
	if (locale === "bn") return bn_admin_create_account(inputs)
	if (locale === "zh-TW") return zh_tw2_admin_create_account(inputs)
	if (locale === "zh-HK") return zh_hk2_admin_create_account(inputs)
	if (locale === "ur") return ur_admin_create_account(inputs)
	if (locale === "fa") return fa_admin_create_account(inputs)
	if (locale === "sw") return sw_admin_create_account(inputs)
	if (locale === "nl") return nl_admin_create_account(inputs)
	return en_admin_create_account(inputs)
});